import styled from "styled-components";

export const Container = styled.div`
  margin: 0 10%;
  td {
    color: #696969;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  tr :last-child {
    font-weight: 400;
  }
`;
export const FormContainer = styled.div`
  /* display: flex; */
  width: 100%;
  margin-left: 14%;
  margin-top: 1em;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    justify-content: center;
    margin-top: 1.63em;
    margin-left: 0%;
  }
`;
export const InfoContact = styled.div`
  color: #000;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 3em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
   
  }
`;
export const ContactUs = styled.span`
  cursor: pointer;
  color: #000;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
`;

export const Info = styled.div`
  width: 19.5em;
  height: fit-content;
  margin-top: 2em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const CardContainer = styled.div`
  /* width: 60%; */
  flex-shrink: 0;
  align-items: center;
  margin-top: -1em;
  max-height: 25em;
  overflow: auto;
  & {
    scrollbar-width: normal;
  }
  &::-webkit-scrollbar {
    width: 0.4em;
  }
  &::-webkit-scrollbar-thumb {
    background: #cecece;
    border-radius: 1em;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #000;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
  }
  @media (max-width: ${({ theme }) => theme.mobile.sm}) {
    &::-webkit-scrollbar {
      width: 0em;
      
    }
  }

  div {
    h3 {
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 1.69em;
  }
`;
export const Empty = styled.div`
  width: 50%;
  margin: 0 auto;

  p {
    margin-top: 3.1em;
    text-align: center;
    color: #ccc;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    padding-left: 5em;
    padding-right: 0%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 5em;
    padding-left: 0em;
  }
`;
export const ImageContainer = styled.div`
  width: 5.625rem;
  height: 5.625rem;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
  }
`;
export const CardHeading = styled.h3`
  color: #929292;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding-top: 1.31em;
    border-top: 1px solid #d9d9d9;
  }
`;

export const Views = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.44em;
  img {
    margin-right: 1.13em;
    width: 1.125rem;
    height: 1.125rem;
  }
  p {
    color: #000;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
export const Subscribers = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.88em;
  img {
    margin-right: 1.13em;
    width: 1.125rem;
    height: 1.125rem;
  }
  p {
    color: #000;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const CardSection = styled.div`
  width: 362px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #f4f4f4;
  background: #fff;
  display: flex;
  padding: 0.5em 1.5em;
  align-items: center;
  margin-bottom: .5em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
